import { call, put, takeLatest } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { IMucThuKhacSinhVienSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eThuPhiActionIds } from "../../action-types/thu-phi/IThuPhiActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IBienLaiThuCreateRequest } from "./../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IThuPhiActionTypes } from "./../../action-types/thu-phi/IThuPhiActionTypes";

export function* thuPhiSaga(): any {
  yield takeLatest(eThuPhiActionIds.LOAD_MUC_THU_KHAC_START, loadWorker);
  yield takeLatest(eThuPhiActionIds.ADD_NEW_TAB_BY_ID, addNewTabWorker);
  yield takeLatest(
    eThuPhiActionIds.CREATE_BIENLAITHU_START,
    createBienLaiWorker,
  );
  yield takeLatest(
    eThuPhiActionIds.PREVIEW_BIENLAITHU_START,
    previewBienLaiWorker,
  );
}

function* loadWorker(action: IThuPhiActionTypes): any {
  const request = action.payload as IMucThuKhacSinhVienSelectRequest;
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectKhoanThuSinhVien,
    request,
  );
  if (res.is_success) {
    const data: IMucThuKhacSinhVienViewModel[] = res.data;
    yield put(
      rootActions.thuPhi.thuPhi.LOAD_MUC_THU_KHAC_SUCCESS({
        request: request,
        data,
      }),
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhi.LOAD_MUC_THU_KHAC_ERROR({
        request: request,
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

function* createBienLaiWorker(action: IThuPhiActionTypes): any {
  const request = action.payload as IBienLaiThuCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Create, request);
  if (res.is_success) {
    const data: number = res.data;
    yield put(rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data));
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: request.hoc_ky,
        nam_hoc: request.nam_hoc,
        id_sv: request.id_sv,
      }),
    );

    yield put(
      rootActions.thuPhi.thuPhi.CREATE_BIENLAITHU_SUCCESS({
        request: {
          ...request,
          dot: 0,
        },
        data,
      }),
    );
    yield put(
      rootActions.report.sinhVien.LOAD_LUY_KE_SO_LIEU_START(request.id_sv),
    );
    // yield put(
    //   rootActions.mucThu.mucthuTamThu.LOAD_SO_TIEN_CON_LAI_LOAD_START(
    //     request.id_sv
    //   )
    // );
  } else {
    yield put(
      rootActions.thuPhi.thuPhi.CREATE_BIENLAITHU_ERROR({
        request: {
          ...request,
          dot: 0,
        },
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

function* addNewTabWorker(action: IThuPhiActionTypes): any {
  const request = action.payload as string;
  const res: IBaseRespone = yield call(sinhVienApi.SelectById, request);
  if (res.is_success) {
    const data: IStuHoSoSinhVienViewModel = res.data;
    yield put(rootActions.thuPhi.thuPhi.ADD_NEW_TAB(data));
  } else {
    yield put(
      rootActions.thuPhi.thuPhi.ADD_NEW_TAB_BY_ID_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* previewBienLaiWorker(action: IThuPhiActionTypes): any {
  const request = action.payload as IBienLaiThuCreateRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Preview, request);
  if (res.is_success) {
    const data: string = res.data;
    yield put(
      rootActions.thuPhi.thuPhi.PREVIEW_BIENLAITHU_SUCCESS({
        request: {
          ...request,
          dot: 0,
        },
        data,
      }),
    );
  } else {
    yield put(
      rootActions.thuPhi.thuPhi.PREVIEW_BIENLAITHU_ERROR({
        request: {
          ...request,
          dot: 0,
        },
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}
